document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.benefitsSection');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var badge = section.querySelector('.productBadge');
    var title = section.querySelector('.benefitsTitle');
    var headerVisible = false;

    if (badge) badge.classList.add('is-reveal-ready');
    if (title) title.classList.add('is-reveal-ready');

    function hideHeader() {
      if (badge) badge.classList.remove('is-visible');
      if (title) title.classList.remove('is-visible');
      headerVisible = false;
    }

    function revealHeader() {
      if (headerVisible) return;
      headerVisible = true;
      if (badge) badge.classList.add('is-visible');
      if (title) {
        setTimeout(function () {
          title.classList.add('is-visible');
        }, 120);
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealHeader();
            } else {
              hideHeader();
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(section);
    } else {
      revealHeader();
    }
  });
});
